import { useContext, useRef, useEffect } from 'react';
import { MapChildContext } from './context.js';

function MapBounds(props) {
  const {
    map,
    setBounds
  } = useContext(MapChildContext);
  const {
    padding = 0,
    duration: durationFromProps = 200,
    bounds
  } = props;
  const durationRef = useRef(durationFromProps);
  useEffect(() => {
    durationRef.current = durationFromProps;
  }, [durationFromProps]);

  // Handle change in bounds
  useEffect(() => {
    if (!map || !bounds) {
      return;
    }
    const duration = durationRef.current;
    setBounds(bounds, padding, duration);
    map.fitBounds(bounds, {
      padding,
      duration
    });
  }, [map, bounds, padding, setBounds]);
  return null;
}

export { MapBounds as default };
//# sourceMappingURL=MapBounds.js.map
